<template>
    <div>
        <!-- Skeleton loader -->
        <TransitionFade v-if="load">
            <div>
                <div class="flex items-baseline justify-end md:justify-between p-4 lg:px-12 py-5 lg:py-3">
                    <div class="hidden md:block">
                        <div class="h-2.5 bg-gray-200 rounded-full w-24 mb-4"></div>
                    </div>
                    <div class="text-3xl lg:text-5xl font-semi-bold text-right">
                        <div class="h-2.5 bg-gray-200 rounded-full w-48 mb-4"></div>
                    </div>
                </div>
                <MoleculeCardEventSkeleton v-for="index in 5" :key="index"/>
            </div>
        </TransitionFade>

        <p class="p-4 lg:px-12 py-5 lg:py-3">{{ $t('project.title') }}</p>
        <MoleculeCardProject v-for="project in projects" :project="project" :key="project.id" />

    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import TransitionFade from "../../../transitions/TransitionFade.vue";
import MoleculeCardEventSkeleton from "../../event/molecules/MoleculeCardEventSkeleton.vue";
import MoleculeCardProject from "../molecules/MoleculeCardProject.vue";

export default {
    name: "OrganismProject",
    components: { MoleculeCardProject, TransitionFade, MoleculeCardEventSkeleton },

    data() {
        return {
            load: true,
        }
    },

    computed: {
        ...mapState('project', {
            projects: 'projects',
        }),
    },

    methods: {
        ...mapActions('project', {
            getProjects: 'getProjects',
        }),

        handleGetProjects() {
            this.getProjects().then(() => this.load = false)
        },
    },

    mounted() {
        this.projects.length === 0 ? this.handleGetProjects() : this.load = false
    },
}
</script>

